export default __webpack_public_path__ + "bml-module6ca8e4.png";